const initialData = {
	rundown: {
		locked: true,
		cueToEdit: null,
	},
	syncing: false,
	ip_addresses: [],
	socket_connected: true,
};

const reorderCues = (cues, oldIndex, newIndex) => {
	console.log("hi", cues, oldIndex, newIndex);
	const cuesArray = Array.from(cues);

	cuesArray.splice(oldIndex, 1);
	cuesArray.splice(newIndex, 0, cues[oldIndex]);

	console.log(cuesArray);

	return cuesArray;
};

export default function mainReducer(state = initialData, action) {
	switch (action.type) {
		case "UPDATE_MAIN_STORE":
			return { ...state, ...action.data };

		case "CHOOSE_SETTING_CATEGORY":
			return { ...state, selectedCategory: action.category };

		case "SYNCING":
			return { ...state, syncing: action.syncing };

		case "SOCKET_CONNECTED":
			return { ...state, socket_connected: true };

		case "SOCKET_DISCONNECTED":
			return { ...state, socket_connected: false };

		case "REORDER_CUE":
			state = {
				...state,
				projects: {
					...state.projects,
					[action.projectId]: {
						...state.projects[action.projectId],
						cues: [
							...reorderCues(
								state.projects[action.projectId].cues,
								action.oldIndex,
								action.newIndex
							),
						],
					},
				},
			};
			break;

		default:
			return state;
	}
}
